import api from "@services/api";

function getClimas() {
  return api.get("/clima");
}
function getClimaUpdateInfo() {
  return api.get("/clima/info");
}
function runUpdate() {
  return api.post("/clima");
}

const climaService = {
  getClimas,
  getClimaUpdateInfo,
  runUpdate,
};

export default climaService;
